import React, {useEffect, useRef,useState } from "react"; 
import { getEnvUrl,getToken } from "../../../utils/Api"; 
import {getLogs} from '../../../Services/logsServices';
import Loader from "../../common/loader";
import ViewLogs from "./viewLogs";
import { checkPermissions } from "../../../Services/User/User";
import { useNavigate } from "react-router-dom";
const $ = require("jquery");
require("datatables.net");
const Logs = ({}) => { 
  const tableRef = useRef(null); 
  const [isLoading, setIsLoading]       = useState(true);
  const [logData, setLogData]           = useState([]);
  const [logViewModal, setLogViewModal] = useState(false);
  const [errFileName, setErrFileName]   = useState('');
  const navigate = useNavigate();
  useEffect(() => {
    const fetchData = async () => {
      try { 
        const response = await getLogs({logtype:'error'});  
        await setLogData(response.data)
        setIsLoading(false)
      } catch (error) {
        // Handle errors
        // setError(error);
      } 
    }; 
    fetchData();  
  }, []);


  useEffect(  () => {  
    if(!checkPermissions('log_page') || !checkPermissions('developer_navigation')){ 
        navigate('/')
      }
    if(!isLoading){
      $(tableRef.current).DataTable()
    }
}, [isLoading]); 
  
const logViewModalClose = () => {
  setLogViewModal(false);
}
const downloadErrorFile = (errorFile) => {
  window.location.href = `${getEnvUrl()}/admin/logs/downloadErrorLog/${errorFile}/${getToken()}`;
}
  return (  
    <div> 
        <main id="main" className="main">
      <div className="pagetitle">
      <h1>Error Logs</h1> 
      </div>
    <section className="section">
          <div className="row">
            <div className="col-lg-12">
            <div className="card p-10">
                <div className="card-body">
                   
                {isLoading?
                    <Loader />
                  :<table
                        className="table table-striped table-hover table-bordered no-footer dataTable"
                        width="100%"
                        ref={tableRef}
                        id='errorlogs'
                      >
                        <thead>
                        <tr>
                          <th>S No</th>
                          <th>Log name</th>
                          <th>Size</th>
                          <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody id="logtablebody">
                    {logData?.map((item, idx) => (  
                     <tr>
                        <td>{idx+1}</td>
                        <td>{item.fileName}</td>
                        <td>{item.fileSize}</td>
                        <td><div> 
                          {checkPermissions('log_view') && <span className="a-view"  data-bs-target="#viewlogs"  onClick={() => { setErrFileName(item.fileName); setLogViewModal(true); }}><i className="bi bi-eye-fill"></i></span>}
                         {checkPermissions('log_download') && <span className="a-delete"  onClick={() => { downloadErrorFile(item.fileName); }}><i className="bi bi-cloud-download-fill"></i></span>}
                        </div></td>
                    </tr> ))}

                    </tbody>
                      </table>}
                </div>
              </div> 
              </div>
          </div>
        </section>
    </main>  
    {logViewModal ? <ViewLogs isShow={logViewModal} close={logViewModalClose} fileName={errFileName} /> : ''}
   
   </div>
  );
};
export default Logs;
 
    